import { ReactNode } from "react";
import { Flex } from "@chakra-ui/react";
import Header from "./Header";
import Transactions from "./Transactions";
import Participate from "./Participate";
import TotalParticipants from "./TotalParticipants";
import Breadcrumbs from "./Breadcrumbs";
import StakeTable from "./StakeTable";
import { Footer } from "./Footer";

type Props = {
  children?: ReactNode;
};
/**
 * 
 * @param param0 
 * @returns 
 *  width: "100vw",
    height: "100%",
    display: "flex",
    flexWrap: "wrap";
    alignItems: "center";
    justify-content: "center";
    position: "fixed";
    left: 0;
    top: 0;
    z-index: 99;
    transition: all cubic-bezier(0.785, 0.135, 0.15, 0.86) 1s;
    overflow: "hidden";
 */
export default function Layout({ children }: Props) {
  return (
    <>
           
        <section className="loader_first" style={{
          width: "100vw",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
    position: "fixed",
    left: 0,
    top: 0,
    zIndex:99990
          }}>
            <div className="circular-spinner"></div>
          </section>

            <Header>
              {children}
            </Header>
            <Breadcrumbs></Breadcrumbs>
            <StakeTable></StakeTable>
            <Footer></Footer>
          </>
         
  );
}
